import { createServerFn } from '@tanstack/react-start';

type ContactPayload = {
  first_name: string;
  last_name: string;
  email: string;
  message: string;
};

export const sendContactEmail = createServerFn({ method: 'POST' })
  .inputValidator((data: ContactPayload) => data)
  .handler(async ({ data }) => {
    const serviceUrl = process.env.SERVICE_EMAIL_URL;
    const serviceKey = process.env.SERVICE_EMAIL_KEY;

    if (!serviceUrl) {
      return { error: true, message: "Le service d'envoi d'email n'est pas configuré." };
    }

    const url = `${serviceUrl}/send-contact`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': serviceKey || '',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (result.error) {
      return { error: true, message: "Une erreur est survenue lors de l'envoi." };
    }

    return { error: false, message: 'Votre message a bien été envoyé' };
  });
